<template>
  <div>
    <b-card>
      <b-card-header class="px-3 text-primary">
        <i :class="icon" class="mr-1"></i>
        {{ title }}
      </b-card-header>
      <b-card-body class="p-0">
        <div class="datatable availtable">
          <b-card class="mt-4">
            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="S/L" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="slac"
                      placeholder="SLAC"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!slac"
                        @click="slac = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="passenger"
                      placeholder="Passenger"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!passenger"
                        @click="passenger = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <div class="mx-2">
            <b-table
              :dark="$store.state.darkMode"
              ref="btable"
              striped
              hover
              small
              responsive="sm"
              caption-bottom
              stacked="md"
              show-empty
              :fields="fields"
              :filter="find"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="busy"
              :items="items"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner
                    variant="primary"
                    class="align-middle mr-2"
                  ></b-spinner>
                  <strong class="text-primary">Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(name)="row">
                <a target="_blank" :href="row.item.url">{{ row.item.name }}</a>
              </template>
              <template v-slot:cell(DepartureAirportName)="row"
                >{{ row.item.DepartureAirportName }} (
                {{ row.item.DepartureAirportCode }} )</template
              >
              <template v-slot:cell(Departing)="row"
                >{{ row.item.DepartureDate }}
                {{ row.item.DepartureTime }}</template
              >
              <template v-slot:cell(ArrivalAirportName)="row"
                >{{ row.item.ArrivalAirportName }} (
                {{ row.item.ArrivalAirportCode }} )</template
              >
              <template v-slot:cell(ArrivalDate)="row"
                >{{ row.item.ArrivalDate }} {{ row.item.ArrivalTime }}</template
              >
               <template v-slot:cell(icon)>
                <i :class="icon" class="text-primary"></i>
              </template>
              <!-- <template v-slot:cell(icon)="row">
                <b-button variant="primary" size="sm">
                  <i :class="icon"></i>
                </b-button>
              </template> -->
              <template v-slot:cell()="row">
                <div v-if="badges.find((obj) => obj.key == row.field.key)">
                  <span
                    v-html="
                      badgeField(
                        row.item,
                        badges.find((obj) => obj.key == row.field.key)
                      )
                    "
                  ></span>
                </div>
                <div v-else>{{ row.value }}</div>
              </template>
              <template v-if="actions" v-slot:cell(actions)="row">
                <b-button
                 variant="link"
                  :class="action.class + ' py-0'"
                  size="sm"
                  v-for="action in validActions(row.item)"
                  :key="action.key"
                  @click.stop="actionClicked(action.key, row)"
                  :title="action.label"
                  :disabled="checkedItems.length > 0"
                >
                  <i :class="action.icon"></i>
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <component
                  v-if="actionActive"
                  :is="action.component ? action.component : 'Confirm'"
                  :instanceid="$helpers.instanceid()"
                  :endpoint="endpoint"
                  :fieldtypes="fieldtypes"
                  :selected="selected"
                  :icon="action.icon"
                  :title="action.title"
                  @discard="discard(row)"
                />
              </template>
            </b-table>
          </div>
          <!--     <b-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">Showing {{ rows }} rows</p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="currentPage"
              :per-page="perPage"
              :total="rows"
            ></pagination>
          </b-card-actions>-->
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "Mobile_Hotels",
  props: ["refresh"],
  data() {
    return {
      busy: false,
      title: "Hotels",
      icon: "fa fa-bed",
      endpoint: "mobile_hotels",
      features: ["refresh", "find"],
      perPage: 20,
      currentPage: 1,
      rows: 0,
      passenger: null,
      find: null,
      slac: "",
      passenger: "",
      action: { action: "" },
      actionActive: false,
      actions: [
        {
          key: "view",
          label: "View",
          icon: "fa fa-eye",
          single: true,
          multiple: true,
          modal: {
            action: "delete",
            dispatch: "datadelete",
            variant: "danger",
          },
        },
      ],
      fields: [
        {
          key: "icon",
          label: "",
          class: "text-right-md",
        },
        // class: "text-right-md",
        {
          key: "PaxName",
          label: "Passenger",
          sortable: true,
        },
        {
          key: "TicketNo",
          label: "Ticket#",
          sortable: true,
        },
        {
          key: "Issued",
          label: "Issued",
          sortable: true,
          formatter: (value, key, item) => {
            return this.$moment(value).format("DD/MM/YYYY HH:MM");
          },
        },
        {
          key: "DepartureAirportName",
          label: "Departure",
          sortable: true,
        },
        {
          key: "ArrivalAirportName",
          label: "Arrival",
          sortable: true,
        },
        {
          key: "FlightNo",
          label: "FlightNo",
          sortable: true,
        },
        {
          key: "Airline",
          label: "Airline",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          class: "actions w-140px",
        },
      ],
      fieldtypes: [],
      badges: [],
      items: [],
      checkedItems: [],
      filter: [],
    };
  },
  mounted() {
    this.fields.splice(0, 0, {
      key: "features",
      label: "",
      class: "features text-center pl-0 pr-0 w-20px",
    });
    let name =
      this.user.lastname + "/" + this.user.firstname + " " + this.user.title;
    this.passenger = name.toUpperCase();
    this.slac = this.user.slac;
    this.loadData();

    var thElm;
    var startOffset;

    Array.prototype.forEach.call(
      document.querySelectorAll("table th"),
      function (th) {
        th.style.position = "relative";

        var grip = document.createElement("div");
        grip.innerHTML = "&nbsp;";
        grip.style.top = 0;
        grip.style.right = 0;
        grip.style.bottom = 0;
        grip.style.width = "5px";
        grip.style.position = "absolute";
        grip.style.cursor = "col-resize";
        grip.addEventListener("mousedown", function (e) {
          thElm = th;
          startOffset = th.offsetWidth - e.pageX;
        });

        th.appendChild(grip);
      }
    );

    document.addEventListener("mousemove", function (e) {
      if (thElm) {
        thElm.style.width = startOffset + e.pageX + "px";
      }
    });

    document.addEventListener("mouseup", function () {
      thElm = undefined;
    });
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    refresh: {
      handler(newVal, oldVal) {
        this.loadData();
      },
    },
  },
  methods: {
    async loadData() {
      this.text = "Querying...";
      this.busy = true;
      let variables = {};
      console.log("variables: ", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query mobile_hotels($slac: String, $pax: String, $paxid: Int) {
              mobile_hotels(slac: $slac, pax: $pax, paxid: $paxid) {
                id
                result {
                  BookingFormNo
                  ConfirmationNo
                  BookingAgent
                  BookingAgentNo
                  EventCode
                  EventName
                  ClientCoCode
                  ClientCoName
                  HotelName
                  HotelTelephone
                  HotelFax
                  HotelEmail
                  HotelWeb
                  YourRef
                  HotelAddress1
                  HotelAddress2
                  HotelAddress3
                  HotelAddress4
                  HotelAddress5
                  OurRef
                  ClientName
                  Accommodation
                  ArrivalDate
                  MealPlan
                  Remarks
                  NumberOfNights
                  RoomNumber
                  DepartureDate
                  BodyNo
                }
              }
            }
          `,
          variables,
        });
        console.log("query result", response.data.mobile_hotels);
        this.items = response.data.mobile_hotels.result;
      } catch (error) {}
      this.busy = false;
      await this.$emit("refreshed");
    },
    rowClass(item, type) {
      if (!item) return;
      if (item.new === true) return "table-bold";
    },
    validActions(item) {
      var valid = [];
      for (var i = 0; i < this.actions.length; i++) {
        if (this.actions[i].rule) {
          var rule = this.actions[i].rule;
          var op = rule.toString().substring(0, 1);
          var equalTo = true;
          if (op == "!") {
            equalTo = false;
            rule = rule.substring(1);
          }
          if (item.hasOwnProperty(rule)) {
            var state = item[rule];
            if (
              (state == true && equalTo == true) ||
              (state == false && equalTo == false) ||
              (state && equalTo == true) ||
              (!state && equalTo == false)
            ) {
              valid.push(this.actions[i]);
            }
          } else {
            valid.push(this.actions[i]);
          }
        } else {
          valid.push(this.actions[i]);
        }
      }
      return valid;
    },
  },
};
</script>

<style>
</style>